import { useMemo } from "react"
import {
  Block,
  FlexGrid,
  FlexGridItem,
  HeadingMedium,
  ParagraphLarge,
  useStyletron,
} from "@mezo-org/mezo-clay"

import bannerImage from "#/assets/home-hero-section.svg"
import {
  selectActiveDeposits,
  selectMats,
  selectUserHasLoan,
  useDappSelector,
} from "#/redux-state"
import CurrencySymbol from "#/shared/components/CurrencySymbol"

import HomepageMainSectionBorrowButton from "./HomepageMainSectionBorrowButton"

export default function HomepageMainSectionBorrow() {
  const activeDeposits = useDappSelector(selectActiveDeposits)
  const hasLoan = useDappSelector(selectUserHasLoan)
  const { totalMats } = useDappSelector(selectMats)

  const [css] = useStyletron()

  const showSection = useMemo(
    () => activeDeposits.length === 0 && !hasLoan && totalMats === 0,
    [activeDeposits.length, hasLoan, totalMats],
  )

  if (!showSection) return null

  return (
    <Block overflow="hidden" className={css({ borderRadius: "16px" })}>
      <FlexGrid
        flexGridColumnCount={2}
        backgroundColor="backgroundTertiary"
        overrides={{ Block: { style: () => ({ flexWrap: "nowrap" }) } }}
      >
        <FlexGridItem padding="48px 48px 78px">
          <HeadingMedium marginBottom="16px">
            Borrow on your bitcoin, <br /> collect cool stuff.
          </HeadingMedium>
          <ParagraphLarge color="contentPrimary" marginBottom="32px">
            You can use <CurrencySymbol token="mBTC" /> as collateral to borrow{" "}
            <br />
            <CurrencySymbol token="MUSD" /> that you can use to collect your
            test swag.
          </ParagraphLarge>
          <HomepageMainSectionBorrowButton />
        </FlexGridItem>
        <FlexGridItem
          display={["none", "none", "none", "block"]}
          overrides={{
            Block: { style: () => ({ flexGrow: 0, width: "auto" }) },
          }}
        >
          <Block height="350px" width="400px" position="relative">
            <Block
              as="img"
              src={bannerImage}
              alt="Banner"
              position="absolute"
              className={css({ top: "-50px", right: "50px" })}
            />
          </Block>
        </FlexGridItem>
      </FlexGrid>
    </Block>
  )
}
